<template>
  <footer class="bp-titleblock">
    <div class="bp-titleblock__cell bp-titleblock__cell--id">
      <BlueprintMonogram class="bp-titleblock__mark" />
      <div>
        <p class="bp-header__name">
          Daniel Hagen
        </p>
        <p class="bp-label">
          Technologist, Creator &amp; Speaker
        </p>
      </div>
    </div>
    <div class="bp-titleblock__cell">
      <span class="bp-label">Sheet</span>
      <span>1</span>
      <a
        id="pagetop"
        class="bp-link bp-titleblock__top"
        href="#top"
      >Back to top</a>
    </div>
    <div class="bp-titleblock__cell">
      <span class="bp-label">Revision</span>
      <time :datetime="appConfig.buildDate">{{ buildDay }}</time>
    </div>
    <div class="bp-titleblock__cell">
      <span class="bp-label">Elsewhere</span>
      <ul class="bp-titleblock__links">
        <li
          v-for="profile in profiles"
          :key="profile.href"
        >
          <a
            class="bp-link"
            :href="profile.href"
            target="_blank"
            rel="noopener noreferrer"
          >{{ profile.label }}<span class="sr-only"> (opens in a new tab)</span></a>
        </li>
      </ul>
    </div>
    <div class="bp-titleblock__cell">
      <span class="bp-label">Legal</span>
      <ul class="bp-titleblock__links">
        <li>
          <NuxtLink
            class="bp-link"
            to="/apps/privacy-policy"
          >
            Privacy Policy
          </NuxtLink>
        </li>
        <li>
          <NuxtLink
            class="bp-link"
            to="/apps/terms-of-service"
          >
            Terms of Service
          </NuxtLink>
        </li>
      </ul>
    </div>
    <div class="bp-titleblock__cell">
      <span class="bp-label">Copyright</span>
      <span>© {{ year }} {{ siteMetadata?.copyrightText || 'Daniel Hagen' }}</span>
    </div>
  </footer>
</template>

<script setup lang="ts">
const appConfig = useAppConfig()
const year = new Date().getFullYear()

const { data: siteMetadata } = await useAsyncData('site-metadata-footer', () => {
  return queryCollection('site').first()
})

const profiles = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/daniel-b-hagen' },
  { label: 'X / Twitter', href: 'https://twitter.com/dbhagenatx' },
  { label: 'Instagram', href: 'https://instagram.com/dbhagenatx' }
]

const buildDay = computed(() => String(appConfig.buildDate).slice(0, 10))
</script>
